import tools from '@/utils/tools';

//保存基本设置接口
const get = async function(params,that){
  var url = "/backend/statistics/get.html";
  const res = await tools.post(url,params,that);
  return res
}

const list = async function(params,that){
  var url = "/backend/statistics/list.html";
  const res = await tools.post(url,params,that);
  return res
}

const exportStatistics = async function(params,that){
  var url = "/backend/statistics/exportStatistics.html";
  const res = await tools.post(url,params,that);
  return res
}

const statisticsFunction = {
  get,
  list,
  exportStatistics,
}

export default statisticsFunction;


// WEBPACK FOOTER //
// ./src/api/statistics.js